// Staff sign-in (shared stobsy staff accounts, ADMIN_SIGN_IN_GUIDE.md) and calls to this site's API.
import { createBrowserClient } from "@supabase/ssr";

export const supabase = createBrowserClient(
  "https://qnlwwmngytjwxkbytuzi.supabase.co",
  "sb_publishable_qFYsFnJ1wMSUEBpIqAteKQ_gVpc1qhs", // public by design
);

export const forgotUrl = () =>
  `https://websites.seenseven.com/auth/forgot?next=${encodeURIComponent(location.origin + "/")}`;

export class ApiError extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
  }
}

export async function api<T = any>(path: string, method = "GET", body?: unknown): Promise<T> {
  // Staff send their platform token; Gold's own logins are signed in by a cookie instead. The
  // x-gold header tells the Worker the request comes from Gold's own pages.
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  const headers: Record<string, string> = { "x-gold": "1" };
  if (token) headers.Authorization = `Bearer ${token}`;
  if (body !== undefined) headers["content-type"] = "application/json";
  const r = await fetch(`/api/${path}`, { method, headers, body: body === undefined ? undefined : JSON.stringify(body) });
  const json = await r.json().catch(() => ({}));
  if (!r.ok && !json?.data) throw new ApiError(json?.error ?? `Request failed (${r.status})`, r.status);
  return json as T;
}
